<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import { genderFilter, bookingStatusFilter, orderPaymentMethodFilter, paymentStatusMapFilter, taxTypeMap, carrierTypeMap, orderPaymentMethodMap } from '@utils/filter-value-to-text'
import formatDate, { formatGetTime } from '@utils/format-date'
import { formatStatusMessage } from '@utils/request'
import BaseButtonDialog from '@components/BaseButtonDialog'
import { calcTotal, calcBasePrice } from '@utils/order-form'
import { Clipboard } from '@capacitor/clipboard'
import { membreLevelValidityTime } from '@utils/memberLevel'
import scrollToElement from '@utils/scroll-to-element'
import DialogPaidConfirm from '@components/Dialog/DialogPaidConfirm';
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import orderDetailMixin from '@src/mixins/orderDetailMixin'
const paramsItem = () => {
  return {
    type: 'cosmetic',
    title: '',
    priceId: '',
    price: 0,
    qty: 1,
  }
}

const initData = () => {
  return {
    params: [paramsItem()],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    // bankType:'',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    allowExpired: 0,
    coupon: undefined,
    couponCode: '',
    memberId: '',
    prepaidOrderUuid: '',
    byOrderExtrafields: {},
    customerInfos: [],
    // paymentMethod: 'Prepaid',
    paymentMethod: '',
    productId: '',
    bankType: '',
    address: '',
    petId: '',
    city: '',
    district: '',
    errorHandle: false,
    type: 'cosmetic',

    // 假資料先暫做
    storeCredit: '',
    credit: '',
  }
}

const initChildrenData = () => {
  return {
    groupSize: 1,
    startDate: '',
    scheduleItemId: '',
    parentId: '',
    params: [],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    memberId: '',
    paymentMethod: '',
    productId: '',
    bankType: '',
    petId: '',
    type: 'cosmetic',
  }
}

export default {
  components: {
    BaseButtonDialog,
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    OrderChangeStatusDialog: () => lazyLoadComponent(import('@components/OrderChangeStatusDialog')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),
    PetCommentList: () => lazyLoadComponent(import('@components/PetCommentList')),
    NotificationWrite: () => lazyLoadComponent(import('@components/NotificationWrite')),
    DepositOrderForm: () => lazyLoadComponent(import('./DepositOrderForm')),

    /* 重構元件 */
    TotalEdit: () => lazyLoadComponent(import('./components/TotalEdit')),
    AdditionFormOrder: () => lazyLoadComponent(import('./components/AdditionFormOrder')),
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    AddressForm: () => lazyLoadComponent(import('./components/AddressForm')),
    RefundForm: () => lazyLoadComponent(import('./components/RefundForm')),
    NoteForm: () => lazyLoadComponent(import('./components/NoteForm')),
    PaymentEditForm: () => lazyLoadComponent(import('./components/PaymentEditForm')),
    PaymentFormDialog: () => lazyLoadComponent(import('./components/PaymentFormDialog')),
    TotalStatementDetail: () => lazyLoadComponent(import('./components/TotalStatementDetail')),
    TotalStatement: () => lazyLoadComponent(import('./components/TotalStatement')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    OrderPetInfo: () => lazyLoadComponent(import('./components/OrderPetInfo')),
    PetList: () => lazyLoadComponent(import('./components/PetList')),
    DialogPaidConfirm,
  },
  filters: {
    orderPaymentMethodFilter,
    formatDate,
    bookingStatusFilter,
    paymentStatusMapFilter,
    genderFilter,
  },
  mixins: [memberLevelDiscountMixin, orderDetailMixin],
  props: {
    isSpace: {
      type: Number,
      default: 0
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit'].includes(val)
      },
      required: true,
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      orderPaymentMethodMap,
      taxTypeMap,
      carrierTypeMap,
      headerHeight: 0,
      submitData: cloneDeep({
        ...this.defaultValue,
        couponCode: this.defaultValue.coupon ? this.defaultValue.coupon.code : '',
      }),
      childrenSubmitData: cloneDeep({
        ...initChildrenData(),
        ...this.defaultValue,
        id: undefined,
        coupon: undefined,
        parentId: this.defaultValue.id,
        params: [],
        prepaidOrderUuid: '',
        paymentStatus: 'UNPAID',
        groupSize: 1,
        scheduleItemId: this.defaultValue.scheduleItem?.id,
        startDate: `${this.defaultValue.date} ${this.defaultValue.time}`,
        petId: this.defaultValue.pet.id,
        type: 'cosmetic',
      }),
      currentOrder: cloneDeep(this.defaultValue),
      couponInfo: {},
      tryingValidCouponCode: false,
      previousCouponCode: '',
      // 各種 show

      // 全畫面
      totalAllShow: false,
      // 右邊的show，左邊有任何選擇，右邊的show要全部關掉
      memberInfoShow: false,
      editDetailEnabled: false,
      visibleAdditionForm: false,
      addressShow: false,

      // totalShow:true,

      // dialog show
      paymentDialogVisible: false,
      // 各種 loading
      tryingStore: false,
      tryingGetMember: false,

      paymentWay: 'offline',
      userSameAsMember: true,
      statusDialogVisible: false,

      // params 必須先拆開成 服務 加購 變價，然後變價的排序折扣要在最後面，有變動的時候要按照順序塞回submitData.params

      basePrice: 0,

      componentKey: 0,
      createDepositOrderVisible: false,

      assignList: [],
      editAssistantEnabled: false,
      commentList: [],
      petCommentDialogVisible: false,
      orderRefundShow: false,
      tryingRefund: false,
      noteEditShow: false,
      orderHistoryShow: false,
      editPaymentMethodShow: false,
      writeDialogVisible: false,
      tryingSendSMS: false,
      CheckinStatusDialogVisible: false,
      noShowDialogVisible: false,
      checkDialogVisible: false,
      check: {
        helperId: '',
      },
      tryingAssign: false,
      addOrderIndex: 'main', // 這種同個資料用兩種型別其實不太對，後續修正
      deleteIds: [],
      deleteCoupon: {},
      shareLink: '',
      shareDialogVisible: false,
      signDialogKey: 0,
      signDialogVisible: false,
      // 會員資訊
      memberInfo: {
        tags: [],
        phoneCode: '',
        phoneNumber: '',
        level: {}
      },
      memberInfoActiveTab: 'information',

      tryingNoShow: false,
      isChildrenOrderCreating: false,
      payMethods: {
        Cash: '到店付款(現金)',
        StoreCredit: '現場刷卡',
        Atm: '線下匯款',
      },
      tryingCheckIn: false,
      tryingPayOrder: false,
      mapStatusName: {
        'PAID': '訂單資訊',
        'UNPAID': '付款',
      },
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      tryingStoreOrderItem: false,

      // 寵物資訊
      petInfoActiveTab: 'information',
      petShow: false,
      // 是否顯示寵物列表
      isShowPetList: false,
      petList: [],
      showHeader: false,
      // 手機版選單
      activeName: 'info',
      visibleTotalEdit: false,

      // 付款確認dialog
      isDialogPaidConfirmVisible: false,
      paidConfirmValue: {},
    }
  },
  computed: {
    /**
     * @description 這次的寵物資訊
     */
    thisTimeSelectedPetInfo() {
      if (Object.keys(this.defaultValue).length > 0) {
        return this.defaultValue.pet
      } else {
        return {}
      }

    },
    editServiceTotal() {
      let cacheTotal = 0
      if (this.prepaidItem) {
        cacheTotal = 0
      } else if (this.isCouponUsed && !this.hasDeleteCoupon) {
        cacheTotal = this.reservationTotal - this.couponItem.discountValue
      } else if (this.hasCouponInfo) {
        cacheTotal = this.couponPriceTotal
      } else {
        cacheTotal = this.reservationTotal
      }
      return cacheTotal
    },
    editOrderDate() {
      return formatDate(`${this.defaultValue.date} ${this.defaultValue.time}`, 'dateTime')
    },
    isEmptyByOrderExtrafields() {
      return this.defaultValue.byOrderExtrafields instanceof Array
    },
    childrenOrders() {
      return this.defaultValue.childrenOrders.length > 0 ? this.defaultValue.childrenOrders : []
    },
    childrenOrdersHaveInvoice() {
      return this.childrenOrders.filter((item) => !!item.invoice.InvoiceNumber)
    },
    helpSubmitRules() {
      return {
        helperId: [
          {
            required: true,
            message: '請選擇助理',
            trigger: 'change',
          },
        ],
      }
    },
    currentHistory() {
      return this.currentOrder.history
    },
    unPaidAddOrder() {
      return this.childrenOrders.find((item) => {
        return item.paymentStatus === 'UNPAID' && item.status !== 0
      })
    },
    isMainOrder() {
      return this.addOrderIndex === 'main'
    },
    prepaidItem() {
      return this.defaultValue.params.find((item) => {
        return item.type === 'prepaid'
      })
    },
    isCouponUsed() {
      return Object.keys(this.couponItem).length > 0
    },
    hasDeleteCoupon() {
      return this.deleteCoupon.id !== undefined
    },
    reservationItem() {
      return this.defaultValue.params.find((item) => {
        return item.type === 'cosmetic'
      })
    },
    isCouponEditable() {
      const isPrepaidPayment = this.currentOrder.prepaidOrderUuid
      return !this.isPaid && this.reservationTotal > 0 && !isPrepaidPayment && this.isMainOrder
    },

    /************ 寵物資訊相關 start ************/
    personalityContentOrder() {
      return this.defaultValue.pet.questions.personality.join('，')
    },
    healthyContentOrder() {
      const content = this.defaultValue.pet.questions.healthy.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content.join('，')
    },
    behaviorContentOrder() {
      const content = this.defaultValue.pet.questions.behavior.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content
    },
    vaccineContentOrder() {
      let vaccine = ''
      switch (this.defaultValue.pet.questions.vaccine) {
        case 1:
          vaccine = '1 劑'
          break
        case 2:
          vaccine = '2 劑'
          break
        case 3:
          vaccine = '3 劑'
          break
        default:
          break
      }
      return vaccine
    },
    /************ 寵物資訊相關 end ************/

    /* 
      ^^^^^^新的區域^^^^^^
    */

    depositReduce() {
      if (this.memberInfo.depositInfo === undefined) return 0

      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    isHomeService() {
      return this.defaultValue.storeType === 'home'
    },
    isPaid() {
      return this.defaultValue.paymentStatus === 'PAID'
    },
    petSizeId() {
      return this.defaultValue.pet.sizeId
    },
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      /* let validCodeTimeout = '' */
      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '請輸入 Email',
          },
          {
            type: 'email',
            message: '請輸入正確的 Email 格式',
          },
        ],
        fullName: [
          {
            required: true,
            message: '請輸入使用人姓名',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
          },
        ],
        productId: [
          {
            required: true,
            message: '請選擇服務地點',
          },
        ],
        productId2: [
          {
            required: true,
            message: '請選擇服務地點',
          },
        ],
        params: [
          {
            required: true,
            message: '請選擇服務項目',
          },
        ],
        bankType: [
          {
            required: true,
            message: '請選擇轉帳銀行',
          },
        ],
        petId: [
          {
            required: true,
            message: `請選擇${this.$t('reserve.CLIENT')}`,
          },
        ],
        city: [
          {
            required: this.isHomeService,
            message: '請選擇縣市',
          },
        ],
        district: [
          {
            required: this.isHomeService,
            message: '請選擇區域',
          },
        ],
        address: [
          {
            required: this.isHomeService,
            message: '請輸入服務地址',
            trigger: 'blur',
          },
        ],
        prepaidOrderUuid: [
          {
            required: this.isRequiredPrePaid,
            message: `請選擇${this.$t('prepaid.BASE')}方案`,
            trigger: 'change',
          },
        ],
        couponCode: [
          {
            validator: (rule, value, callback) => {
              /* clearTimeout(validCodeTimeout) */
              if (value === '') {
                this.$refs.couponForm.clearValidate('couponCode')
                return callback()
              }
              if (this.previousCouponCode === value) return callback()

              /* validCodeTimeout = setTimeout(() => { */
              this.previousCouponCode = value

              if (value === this.couponItem.code) {
                const resetDeleteCoupon = () => {
                  const { id: couponId } = this.defaultValue.params.find(({ type }) => type === 'coupon')
                  if (couponId === this.deleteCoupon.id) this.deleteCoupon = {}
                }
                resetDeleteCoupon()
                callback()
                this.applyCoupon({ ...this.couponItem })
              } else {
                this.tryingValidCouponCode = true
                this.$store
                  .dispatch('coupon/validCode', {
                    code: value,
                    basePrice: this.submitData.params[0].total,
                    priceId: this.submitData.params[0].priceId,
                    memberId: this.memberInfo.id,
                  })
                  .then((response) => {
                    callback()
                    this.applyCoupon(response.items)
                  })
                  .catch((error) => {
                    this.previousCouponCode = ''
                    callback(new Error(formatStatusMessage(error.status)))
                  })
                  .finally(() => {
                    this.tryingValidCouponCode = false
                  })
              }
              /* }, 500) */
            },
            trigger: 'custom',
          },
        ],
      }
    },
    // 新增訂單時已使用優惠券
    couponItem() {
      return this.defaultValue.coupon || {}
    },
    hasCouponInfo() {
      return Object.keys(this.couponInfo).length !== 0
    },
    couponPriceTotal() {
      const calcFixedDiscount = (value = 0, total = 0) => {
        return total - value < 0 ? 0 : total - value
      }
      const calcPercentDiscount = (value = 0, total = 1) => {
        return total - Math.round(total * (value / 100))
      }
      const basePriceTotal = this.reservationTotal
      const { discount, type } = this.couponInfo

      return this.couponInfo ? (type === 'fixed' ? calcFixedDiscount(discount, basePriceTotal) : calcPercentDiscount(discount, basePriceTotal)) : basePriceTotal
    },
    submitPriceTotal() {
      let total = parseInt(this.editServiceTotal)
      const parentMemberLevelDiscount = this.composeMemberLevelDiscount(this.currentOrder.params[0])
      const memerLevelPercent = typeof (parentMemberLevelDiscount) === 'object' ? parentMemberLevelDiscount : 0
      if (!this.isChildrenOrderCreating) {
        if (!this.isMainOrder) {
          total = 0
        }
        this.updateBasePrice()
        total = calcTotal({ price: total, totalEditList: this.currentOrder.params, memerLevelPercent, memberInfo: this.memberInfo })
      }
      return total
    },
    hasCannotPayByDepositAddition() {
      /* 未來加購項目可能也可以設定成適用項目 */
      // return this.additionList.some((item) => !item.canPayByDeposit)
      return false
    },
    linkTitle() {
      const { childrenOrders } = this.defaultValue
      if (childrenOrders.length) {
        let hasUnpaid = false
        hasUnpaid = childrenOrders.some((order) => order.paymentStatus === 'UNPAID')
        return this.mapStatusName[hasUnpaid ? 'UNPAID' : 'PAID']
      } else return this.mapStatusName[this.defaultValue.paymentStatus]
    },

    /* 會員等級效期 */
    validityTime() {
      const startedAt = this.memberInfo.level.startedAt
      const expiredAt = this.memberInfo.level.expiredAt
      return membreLevelValidityTime(startedAt, expiredAt)
    },
    /* 當前訂單會員等級的折扣 */
    memberLevelDiscount() {
      const map = () => {
        return {
          reservation: this.memberInfo?.level?.discount?.cosmetic,
          prepaid: this.memberInfo?.level?.discount?.prepaid,
          deposit: this.memberInfo?.level?.discount?.deposit,
          homestay: this.memberInfo?.level?.discount?.homestay,
          daycare: this.memberInfo?.level?.discount?.daycare
        }
      }
      return map()[this.orderType] ?? 0
    },
  },
  watch: {
  },
  created() {
    this.fetchExtraInfo()
    this.updateCoupon()
  },
  mounted() {
    const updateHeaderHeight = () => {
      this.$nextTick(() => {
        const interval = setInterval(() => {
          if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
            clearInterval(interval)
            this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
          }
        }, 500)
      })
    }
    updateHeaderHeight()
  },
  methods: {
    /**
     * @description 助理文字
     */
     helperWordsMethods(type) {
      if (!this.defaultValue[type]) {
        return '尚未指定'
      } else {
        return this.defaultValue[type].length > 0 ? this.defaultValue[type].map(item => item.name).join('') : '尚未指定'
      }
    },
    async handleStoreOrder() {
      const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
      if (!isBeforeExpired) return this.errorCurrentMemberLevel()
      const isNegative = this.isChildrenOrderCreating ? this.childrenOrderTotal < 0 : this.submitPriceTotal < 0

      if (isNegative) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }
      this.tryToCreateChildrenOrder()
    },
    async handleDepositPayment() {
      const mainOrderTotal = this.submitPriceTotal
      const isDepositInsufficient = this.isChildrenOrderCreating ? this.depositReduce < this.childrenOrderTotal : this.depositReduce < mainOrderTotal

      if (this.isChildrenOrderCreating) {
        if (this.hasCannotPayByDepositAddition) {
          await this.$confirm(`加購項目中某幾項未設定可使用儲值點數抵扣，請問是否確定抵扣 ${this.childrenOrderTotal} 點？`, '抵扣未開放', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else {
          await this.$confirm(`確定要使用儲值金抵扣 ${this.childrenOrderTotal} 點？`, '提醒', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }
      } else if (this.reservationItem.canPayByDeposit === false) {
        await this.$confirm(`${this.hasCannotPayByDepositAddition ? '加購項目中某幾項' : '此方案'}未設定可使用儲值點數抵扣，請問是否確定抵扣 ${mainOrderTotal} 點？`, '抵扣未開放', {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
      } else {
        await this.$confirm(`確定要使用儲值金抵扣 ${mainOrderTotal} 點？`, '提醒', {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
      }

      if (isDepositInsufficient) {
        await this.$confirm(`儲值金餘額不足，是否加值`, '提醒', {
          confirmButtonText: '確定',
          // showCancelButton: false,
          type: 'warning',
          center: true,
        })
        this.createDepositOrderVisible = true
        return
      }

      this.childrenSubmitData.paymentMethod = 'Deposit'

      this.tryToCreateChildrenOrder()
    },
    async tryToCreateChildrenOrder() {
      let storeData = {
        ...this.childrenSubmitData,
        basePrice: this.basePrice,
        total: this.childrenOrderTotal,
      }
      storeData.paymentMethod = ''
      storeData.paymentStatus = 'UNPAID'
      delete storeData.status
      this.tryingStore = true

      try {
        await this.$store.dispatch('order/store', storeData)
        let requirePay = storeData.paymentStatus === 'PAID' ? false : storeData.paymentStatus === 'UNPAID' && storeData.total > 0

        this.handleCreateSuccess(requirePay)
        this.paymentDialogVisible = false
        this.closeChildren()
        this.updateOrder()
      } catch (error) {
        if (error.status === 'SCHEDULE_ITEM_CALENDAR_TIME_UNAVAILABLE')
          this.$message({
            type: 'warning',
            message: `與該訂單時段重疊： ${formatDate(new Date(error.data.date), 'dateTime')}`,
          })
        if (error.status === 'SCHEDULE_ITEM_ADMIN_ITEM_NOT_EXIST')
          this.$message({
            type: 'error',
            message: `此排班不存在或該排班人員不存在`,
          })
        else
          this.$message({
            type: 'error',
            message: `Server Error`,
          })
      } finally {
        this.tryingStore = false
      }
    },
    handleCreateSuccess(requirePay = false) {
      this.emitStore()
      this.$alert(`已發送${requirePay ? '付款' : '訂單'}連結至使用人 Email`, '訂單新增成功！', {
        confirmButtonText: '確認',
        center: true,
      })
    },
    onSubmitPaymentForm(data) {
      const { paymentMethod, Card4No, PayerAccount5Code, bankType, isPaid } = data
      this.childrenSubmitData = {
        ...this.childrenSubmitData,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
        paymentStatus: isPaid ? 'PAID' : 'UNPAID',
      }
      this.tryToCreateChildrenOrder()
    },
    emitStore() {
      this.$emit('store')
    },
    openTotalEdit() {
      this.totalAllShow = true
      this.visibleAdditionForm = false
    },
    openAddEdit() {
      this.totalAllShow = true
      this.visibleAdditionForm = true
    },
    //  手機版打開變價
    openChangeEdit() {
      this.totalAllShow = true
      this.visibleTotalEdit = true
    },
    closeChange() {
      this.visibleTotalEdit = false
    },
    closeAdd() {
      this.visibleAdditionForm = false
    },
    cancelToTalEdit({ resetCoupon = true } = {}) {
      if (resetCoupon) this.updateCoupon()
      this.totalAllShow = false
    },
    applyCoupon(couponData) {
      this.couponInfo = couponData
    },
    validCoupon() {
      this.$refs.couponForm.validateField('couponCode')
    },
    resetCoupon() {
      this.couponInfo = {}
      this.previousCouponCode = ''
      this.$refs.couponCode.resetField('couponCode') // 留意
      this.submitData.couponCode = '' // resetField 有時不會work 所以還要清空couponCode
      if (this.couponItem) {
        const { total: price, ...other } = this.couponItem
        const id = this.defaultValue.params.find(({ type }) => type === 'coupon').id
        this.deleteCoupon = {
          ...other,
          price,
          id,
        }
      }
    },
    openAddressEdit() {
      this.closeLayout()
      this.addressShow = true
    },
    closeAddress() {
      this.addressShow = false
    },
    async saveHomeAddress({ syncAddress, data }) {
      const { city, district, address } = data
      this.currentOrder.city = city
      this.currentOrder.district = district
      this.currentOrder.address = address
      this.tryToSaveOrder()
    },
    async onCreateDepositOrderDone() {
      this.$refs.depositOrderForm.closeDrawer()
      await this.tryToFetchDetail(this.memberInfo.id)
    },

    /* 
      新的區域
    */
    closeLayout() {
      this.editDetailEnabled = false
      this.memberInfoShow = false
      this.addressShow = false
      this.visibleAdditionForm = false

      this.noteEditShow = false
    },
    updateCoupon() {
      if (this.submitData.coupon) {
        this.couponInfo = { ...this.submitData.coupon }
        this.submitData.couponCode = this.submitData.coupon.code
      }
    },
    fetchExtraInfo() {
      this.tryToFetchDetail(this.defaultValue.memberId)
      this.tryToFetchHelperList()
    },
    goToDetail() {
      this.closeAllInfo()
      this.memberInfoShow = true
    },
    closeAllInfo() {
      this.memberInfoShow = false
      this.noteEditShow = false
    },
    async tryToRefund(refundData) {
      if (refundData.paymentMethod !== 'Deposit') {
        // 輸入金額小於等於上限，且大於建議值表示會虧本
        if (refundData.amount <= this.currentOrder.backBalance && refundData.amount > this.currentOrder.recommendRefundValue.amount) {
          await this.$confirm('虧本', '提示', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else if (refundData.amount > this.currentOrder.backBalance) {
          // 輸入金額大於上限
          this.$confirm('退款金額不能超過退款上限', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          return
        }
      } else {
        if (refundData.amount > this.currentOrder.recommendRefundValue.amount) {
          await this.$confirm('虧本', '提示', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }
      }
      try {
        this.tryingRefund = true
        await this.$store.dispatch('order/refundOrder', {
          id: this.currentOrder.id,
          refundData: refundData,
        })
        this.$confirm('退款已完成', '提示', {
          confirmButtonText: '關閉',
          showCancelButton: false,
          type: 'success',
          center: true,
        })
        this.updateOrder()
        this.orderRefundShow = false
        this.tryToFetchDetail(this.memberInfo.id)
      } catch (error) {
        console.error('TCL: refundOrder -> error', error)
      } finally {
        this.tryingRefund = false
      }
    },
    closeOpenRefund() {
      this.orderRefundShow = false
    },
    closeHistory() {
      this.orderHistoryShow = false
    },
    // 子訂單的show要另外寫 orderItem必須做成編輯的樣式
    editOpenTotalEdit(index) {
      this.totalAllShow = true
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue) // 如果同時有編輯多個地方 用submitData會存到我當下沒有想要存的東西，所以複製defaultValue來改比較好
      } else {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.childrenOrders[index])
      }
      let list = [...this.currentOrder.params]
      if (index === 'main') {
        list.splice(0, 1)
        list.forEach((item, index) => {
          if (item.type === 'coupon') {
            list.splice(index, 1)
          }
        })
        list.forEach((item, index) => {
          if (item.type === 'prepaid') {
            list.splice(index, 1)
          }
        })
      }

      list = list.map((item) => {
        let { total, ...other } = item
        if (item.type === '-') {
          total = -total
        }
        if (item.type === '%') {
          total = parseInt(item.description)
        }
        return {
          ...other,
          price: total,
        }
      })
      this.deleteIds = []
    },
    editOpenPaymentMethod(index) {
      if (index === 'main') {
        this.addOrderIndex = index

        this.currentOrder = cloneDeep(this.defaultValue)
        // 取得 bankType
        delete this.currentOrder.bankType
        if (this.currentOrder.Vacc) {
          this.currentOrder = {
            ...this.currentOrder,
            bankType: this.currentOrder.Vacc.BankType,
          }
        }
      } else {
        this.addOrderIndex = index

        this.currentOrder = cloneDeep(this.childrenOrders[index])
        // 取得 bankType
        delete this.currentOrder.bankType
        if (this.currentOrder.Vacc) {
          this.currentOrder = {
            ...this.currentOrder,
            bankType: this.currentOrder.Vacc.BankType,
          }
        }
      }

      this.editPaymentMethodShow = true
    },
    editOpenHistory(index) {
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue)
      } else {
        this.addOrderIndex = index

        this.currentOrder = cloneDeep(this.childrenOrders[index])
      }

      this.orderHistoryShow = true
    },
    tryToCancelOrder(index) {
      this.statusDialogVisible = true
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue)
      } else {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.childrenOrders[index])
      }
    },
    editOpenRefund(index) {
      if (index === 'main') {
        this.addOrderIndex = index
        this.currentOrder = cloneDeep(this.defaultValue)
      } else {
        this.addOrderIndex = index

        this.currentOrder = cloneDeep(this.childrenOrders[index])
      }
      this.refundSubmitData = {
        refundDate: formatDate(new Date(), 'date-dash'),
        amount: this.currentOrder.recommendRefundValue.amount,
        note: '',
        paymentMethod: '',
        bonus: this.currentOrder.recommendRefundValue.bonus,
      }
      this.orderRefundShow = true
    },
    openAddOrder() {
      const checkHasUnpaidOrder = () => {
        const isUnPaid = this.defaultValue.paymentStatus === 'UNPAID'
        const isChildrenUnPaid = this.childrenOrders.some((item) => {
          return item.paymentStatus === 'UNPAID' && item.status !== 0
        })

        if (isUnPaid || isChildrenUnPaid) {
          this.$confirm('未付款前，加購請於原來的訂單中選擇『編輯價格與折扣』', '提醒', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          return true
        }
        return false
      }

      if (!checkHasUnpaidOrder()) {
        this.childrenSubmitData.params = []
        this.totalAllShow = true
        this.visibleAdditionForm = true
        this.isChildrenOrderCreating = true
      }
    },
    showShareDialog() {
      this.shareDialogVisible = true
    },
    closeNotificationDialog() {
      this.writeDialogVisible = false
    },
    async tryToGetShareLink() {
      this.shareLink = await this.$store.dispatch('order/getLink', this.defaultValue.id)
    },
    handleShareLink(platform) {
      // <!-- <a href=”fb-messenger://share/?link= https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fsharing%2Freference%2Fsend-dialog&app_id=123456789”>Send In Messenger</a> -->
      const platformLinkMap = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.shareLink}`,
        line: `https://social-plugins.line.me/lineit/share?url=${this.shareLink}`,
      }
      window.open(platformLinkMap[platform], '_blank')
    },
    async tryToSendSMS() {
      this.tryingSendSMS = true
      try {
        await this.$store.dispatch('order/sendLink', {
          orderId: this.defaultValue.id,
          router: 'sms',
        })
        this.$alert(`已發送${this.linkTitle}連結簡訊至使用人電話`, '簡訊發送成功！', {
          confirmButtonText: '確認',
          center: true,
          callback: () => {
            this.tryingSendSMS = false
          },
        })
      } catch (error) {
        this.tryingSendSMS = false
      }
    },
    async copyShareLink() {
      const ghostInput = document.createElement('INPUT')
      document.body.appendChild(ghostInput)
      ghostInput.setAttribute('value', this.shareLink)
      ghostInput.select()
      document.execCommand('copy')
      document.body.removeChild(ghostInput)

      if (process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
        await Clipboard.write({
          string: this.shareLink,
        })
      }

      this.$message('連結複製成功')
    },
    showCheckinStatusDialog() {
      this.CheckinStatusDialogVisible = true
    },
    paidConfirm() {
      const paymentMethod = this.paidConfirmValue.paymentMethod
      this.tryToPayOrder(paymentMethod, this.paidConfirmValue)
    },
    openPaidDialog() {
      this.isDialogPaidConfirmVisible = true
      this.paidConfirmValue = this.submitData
    },
    async openAddPaidDialog() {
      // const paymentMethod = this.unPaidAddOrder.paymentMethod
      this.isDialogPaidConfirmVisible = true
      this.paidConfirmValue = this.unPaidAddOrder
      // await this.$confirm(`子訂單：${this.unPaidAddOrder.id} <br> 確認付款方式為「 ${this.payMethods[paymentMethod]} 」？`, '子訂單付款確認', {
      //   confirmButtonText: '是',
      //   cancelButtonText: '否',
      //   showCancelButton: true,
      //   dangerouslyUseHTMLString: true,
      //   customClass: 'isStyleBtnFull',
      //   confirmButtonClass: 'isConfirmBtn',
      //   cancelButtonClass: 'isCancelBtn',
      //   center: true,
      // })
      // this.tryToPayOrder(paymentMethod, this.unPaidAddOrder)
    },
    async tryToPayOrder(method, data) {
      try {
        const { params, ...other } = data
        this.tryingPayOrder = true
        await this.$store.dispatch('order/store', {
          ...other,
          paymentMethod: method,
          paymentStatus: 'PAID',
        })
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        this.updateOrder()
        this.paidDialogVisible = false
      } finally {
        this.tryingPayOrder = false
      }
    },
    goToPrepaidOrder(id) {
      this.$router.push({
        name: 'orders',
        query: {
          type: 'prepaidOrder',
          id,
        },
      })
    },
    openCheckDialog() {
      this.checkDialogVisible = true
      this.check.helperId = this.defaultValue.helper ? this.defaultValue.helper.id : ''
    },
    async onClickNoShow() {
      await this.$refs.form.validate()
      await this.$confirm('確定將此訂單改為「未報到」？', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
      this.tryingNoShow = true
      const { params, ...other } = this.defaultValue
      const storeData = {
        ...other,
        status: 5,
        merchantNote: this.submitData.note,
      }
      try {
        await this.$store.dispatch('order/store', storeData)
        this.updateOrder()
        this.submitData.note = ''
        this.noShowDialogVisible = false
        this.CheckinStatusDialogVisible = false
      } finally {
        this.tryingNoShow = false
      }
    },
    async tryToStoreAssignAndCheckIn() {
      this.tryingCheckIn = true
      await this.$store.dispatch('order/storeAssignHelper', {
        id: this.defaultValue.id,
        itemId: this.check.helperId,
        action: 'add'
      })
      this.tryToCheckIn()
    },
    async tryToCheckIn() {
      await this.$refs.beauticianForm.validate()
      this.checkDialogVisible = false
      try {
        this.tryingCheckIn = true
        await this.$store.dispatch('order/verifySingleCode', {
          codeId: this.reservationItem.codes[0].id,
          orderId: this.defaultValue.id,
        })
        this.$message({
          type: 'success',
          message: '報到成功！',
        })
        this.CheckinStatusDialogVisible = false
        this.updateOrder()
      } finally {
        this.tryingCheckIn = false
      }
    },
    showSignDialog() {
      this.signDialogKey++
      this.signDialogVisible = true
    },
    async tryToStoreOrderItem() {
      const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
      if (!isBeforeExpired) return this.errorCurrentMemberLevel()

      const isNegative = this.submitPriceTotal < 0

      if (isNegative) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }
      const adds = this.currentOrder.params.filter(({ id }) => id === undefined)
      let couponCode

      if (this.isMainOrder) {
        if (this.deleteCoupon.id) {
          this.deleteIds = [this.deleteCoupon.id, ...this.deleteIds]
        }
      }

      if (this.isMainOrder && this.hasCouponInfo) {
        if (this.submitData.couponCode !== this.couponItem.code) couponCode = this.submitData.couponCode
      }

      const data = {
        adds,
        couponCode,
        orderId: this.currentOrder.id,
        deleteIds: this.deleteIds,
        total: this.submitPriceTotal,
      }
      this.tryingStoreOrderItem = true
      try {
        await this.$store.dispatch('order/storeOrderItem', data)
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        this.couponInfo = {}
        this.deleteIds = []
        this.deleteCoupon = {}
        this.updateOrder()
        this.cancelToTalEdit({ resetCoupon: false })
        this.visibleAdditionForm = false
      } finally {
        this.tryingStoreOrderItem = false
      }
    },
    async tryToSaveOrder(type) {
      const { params, ...other } = this.currentOrder
      let storeData = {}

      if (type === 'extraField') {
        storeData = {
          ...this.convertExtraFieldToStoreDataFromEditMode({
            ...other,
          }),
          merchantNote: '',
        }
      } else {
        storeData = {
          ...other,
          merchantNote: '',
        }
      }

      if (this.currentOrder.paymentMethod === 'Deposit') storeData.paymentStatus = 'PAID'

      this.tryingStore = true
      try {
        await this.$store.dispatch('order/store', storeData)
        this.handleSaveSuccess()
        await this.updateOrder()
        // 很多地方都會用到編輯訂單，所以必須關掉很多的介面
        this.noteEditShow = false
        this.editPaymentMethodShow = false
        this.addressShow = false
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    handleSaveSuccess() {
      this.$message({
        message: '編輯成功！',
        type: 'success',
      })
    },
    async updateOrder() {
      const updatedValue = await this.$store.dispatch('order/fetchSingle', this.defaultValue.id)
      this.$emit('update:defaultValue', updatedValue)
      this.submitData = cloneDeep(updatedValue)
      this.updateCoupon()
      this.$emit('update')
    },
    errorCurrentMemberLevel() {
      this.$alert(`超過會員等級方案"${this.memberInfo.level.title}"截止時間，請重新下單`, {
        title: `提示`,
        showClose: false,
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.tryToFetchDetail(this.memberInfo.id)
          this.closeChildren()
          this.cancelToTalEdit()
        })
        .finally(() => {
          this.tryingStoreOrderItem = false
        })

    },
    convertExtraFieldToStoreDataFromEditMode(submitData) {
      const orderInfo = cloneDeep(submitData)
      const getExtraFieldsArray = (extraFields) => {
        const extraFieldsArray = []
        const isEdited = (field) => {
          return field.edited === true
        }
        Object.keys(extraFields).forEach((extraFieldsId) => {
          if (isEdited(extraFields[extraFieldsId])) {
            const { id, value } = extraFields[extraFieldsId]
            extraFieldsArray.push({
              id,
              value,
            })
          }
        })
        return extraFieldsArray
      }
      const getBySizeExtraFieldsArray = (customerInfos) => {
        return customerInfos.map((customerInfo) => {
          return {
            customerInfoId: customerInfo.customerInfoId,
            orderExtrafields: getExtraFieldsArray(customerInfo.bySizeExtrafields),
          }
        })
      }
      if (orderInfo.byOrderExtrafields) orderInfo.byOrderExtrafields = getExtraFieldsArray(orderInfo.byOrderExtrafields)
      if (orderInfo.customerInfos) orderInfo.bySizeExtrafields = getBySizeExtraFieldsArray(orderInfo.customerInfos)

      if (orderInfo.customerInfos) delete orderInfo.customerInfos
      return orderInfo
    },

    closeChildren() {
      this.cancelToTalEdit({ resetCoupon: false })
      this.visibleAdditionForm = false
      this.isChildrenOrderCreating = false
    },
    updateBasePrice(isChildrenOrder = false) {
      if (isChildrenOrder) {
        let basePrice = 0
        if (this.isChildrenOrderCreating) {
          basePrice = calcBasePrice({ price: basePrice, totalEditList: this.childrenSubmitData.params })
        }
        this.basePrice = basePrice
      } else {
        let basePrice = !this.isMainOrder ? 0 : this.reservationTotal
        basePrice = calcBasePrice({ price: basePrice, totalEditList: this.currentOrder.params })
        this.basePrice = basePrice
      }
    },
    async tryToStorePayment() {
      if (this.currentOrder.paymentMethod === 'Deposit') {
        if (this.reservationItem.canPayByDeposit === false) {
          await this.$confirm(`${this.hasCannotPayByDepositAddition ? '加購項目中某幾項' : '此方案'}未設定可使用儲值點數抵扣，請問是否確定抵扣 ${this.currentOrder.priceTotal} 點？`, '抵扣未開放', {
            confirmButtonText: '確定',
            // showCancelButton: false,
            type: 'warning',
            center: true,
          })
        } else {
          await this.$confirm(`確定要使用儲值金抵扣 ${this.currentOrder.priceTotal} 點？`, '提醒', {
            confirmButtonText: '確定',
            // showCancelButton: false,
            type: 'warning',
            center: true,
          })
        }
        if (this.depositReduce < this.currentOrder.priceTotal) {
          await this.$confirm(`儲值金餘額不足，是否加值`, '提醒', {
            confirmButtonText: '確定',
            // showCancelButton: false,
            type: 'warning',
            center: true,
          })
          this.createDepositOrderVisible = true
          return
        }
      }

      this.tryToSaveOrder()
    },

    /************ 編輯客戶資訊相關 start ************/
    closeEditMemberForm() {
      this.editDetailEnabled = false
    },
    async tryToFetchDetail(memberId) {
      this.tryingGetMember = true
      this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })
      this.closeEditMemberForm()
      this.tryingGetMember = false
    },
    /************ 編輯客戶資訊相關 end ************/

    /************ 客戶資訊相關 start ************/
    closeMemberInfo() {
      this.memberInfoShow = false
      if (this.$refs.leftCont) {
        this.scrollTo(this.$refs.leftCont)
      }
    },
    /************ 客戶資訊相關 end ************/

    /************ 編輯備註相關 start ************/
    tryToStoreNote(data) {
      this.currentOrder = data
      this.tryToSaveOrder('extraField')
    },
    /************ 編輯備註相關 end ************/

    /************ 變更付款方式相關 start ************/
    onUpdatePayment(data) {
      const { allowExpired, paymentMethod, Card4No, PayerAccount5Code, bankType } = data
      this.currentOrder = {
        ...this.currentOrder,
        allowExpired,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
      }
      this.tryToStorePayment()
    },
    closeEditPaymentMethod() {
      this.editPaymentMethodShow = false
    },
    /************ 變更付款方式相關 end ************/

    /************ 助理相關 start ************/
    async tryToFetchHelperList() {
      this.tryingAssign = true
      const { items } = await this.$store.dispatch('order/fetchServiceHelperList', {
        orderId: this.defaultValue.id,
        scheduleItemTypes: this.isSpace ? ['space'] : ['cosmetic']
      })
      const excludeCurrentBeautician = () => {
        this.assignList = items.filter(({ id, sameStore }) => id !== this.defaultValue.scheduleItem.id && sameStore)
      }
      excludeCurrentBeautician()
      this.tryingAssign = false
    },
    async tryToStoreAssignHelper() {
      this.tryingAssign = true
      await this.$store.dispatch('order/storeAssignHelper', {
        id: this.defaultValue.id,
        itemId: this.submitData.helper.id,
        action: 'add'
      })
      // 要更新訂單 改這個等於是改訂單
      this.updateOrder()
      this.tryingAssign = false
      this.editAssistantEnabled = false
    },
    cancelAssignEdit() {
      this.editAssistantEnabled = false
    },
    openAssignEdit() {
      this.editAssistantEnabled = true
      if (this.defaultValue.helper) {
        this.submitData.helper = {
          ...this.defaultValue.helper,
        }
      } else {
        this.submitData.helper = {
          id: '',
          name: '',
        }
      }
    },
    /************ 助理相關 end ************/

    /************ 寵物資訊相關 start ************/
    openCommentEdit() {
      this.$refs.comment.openEdit()
    },
    async tryToFetchCommentListAll() {
      // try {
      //   this.commentList = await this.$store.dispatch('comment/fetchList', {
      //     petId: this.defaultValue.pet.id,
      //     paginate: 0,
      //   })
      // } catch {}
      if (this.petShow && this.petInfoActiveTab === 'currentService') {
        this.$refs.petList.$refs.commentAll2.tryToFetchList()
      } else {
        this.petShow = true
        this.petInfoActiveTab = 'currentService'
      }
    },
    emitCommentFetch() {
      this.tryToFetchCommentListAll()
    },
    // openCommentList() {
    //   this.petCommentDialogVisible = true
    //   this.$nextTick(() => {
    //     this.$refs.commentAll.tryToFetchList()
    //   })
    // },
    // updateComment() {
    //   this.$refs.comment.tryToFetchList()
    //   this.tryToFetchCommentListAll()
    // },
    // openSelectPet() {
    //   this.closeAllInfo()
    //   this.serviceType = ''
    //   this.petShow = true
    //   this.isShowPetList = false
    // },
    goToPetInfoDetail(val) {
      this.closeAllInfo()
      if (val.alias === 'addService') {
        this.openCommentEdit()
      } else {
        this.petShow = true
        this.petInfoActiveTab = val.alias
        this.isShowPetList = val.isShowPetList
      }
      if (this.$refs.rightCont) {
        this.scrollTo(this.$refs.rightCont)
      }
    },
    closePet() {
      this.petShow = false
      this.serviceType = ''
      this.isShowPetList = false
      if (this.$refs.leftCont) {
        this.scrollTo(this.$refs.leftCont)
      }
    },
    /************ 寵物資訊相關 end ************/

    /************ 服務備註相關 start ************/
    openNoteEdit() {
      this.noteEditShow = true
      this.editPaymentMethodShow = false
      this.orderHistoryShow = false
      this.orderRefundShow = false

      this.memberInfoShow = false
      this.addressShow = false
    },
    closeNoteEdit() {
      this.noteEditShow = false
    },
    /************ 服務備註相關 end ************/

    /************ 加購相關 start ************/
    onSubmitAddition(list) {
      const formattedList = list.map((item) => ({
        type: 'cosmetic-add',
        title: item.title,
        priceId: item.thisOrderServiceId,
        price: item.price,
        qty: 1,
      }))

      if (this.isChildrenOrderCreating) this.childrenSubmitData.params.push(...formattedList)
      else this.currentOrder.params.push(...formattedList)
    },
    /************ 加購相關 end ************/

    /************ 變價相關 start ************/
    onSubmitTotalEdit(item) {
      if (this.isChildrenOrderCreating) this.childrenSubmitData.params.push({ ...item })
      else this.currentOrder.params.push({ ...item })
    },
    clearParams() {
      if (this.isChildrenOrderCreating) this.childrenSubmitData.params = []
      else this.currentOrder.params = this.currentOrder.params.filter(({ type }) => !['cosmetic-add', '+', '-', '%'].includes(type))
    },
    /************ 變價相關 end ************/

    onUpdateTotalStatement({ params, deleteIds }) {
      this.clearParams()
      if (this.isChildrenOrderCreating) this.childrenSubmitData.params = [...params]
      else this.currentOrder.params = [...this.currentOrder.params, ...params]
      this.deleteIds = [...deleteIds]
    },

    /****** 客戶資訊 ******/
    goToMemberInfoDetail(val) {
      this.closeAllInfo()
      this.memberInfoShow = true
      this.memberInfoActiveTab = val
      if (this.$refs.rightCont) {
        this.scrollTo(this.$refs.rightCont)
      }
    },
    /****** 客戶資訊 end ******/
    hasPrepaidParams(params) {
      return params.some(item => {
        return item.type === 'prepaid'
      })
    },
    scrollTo(el) {
      this.$nextTick(() => {
        scrollToElement(el, 100)
      })
    },
    closeDrawer() {
      this.$emit('closeDrawer')
      this.activeName = "info"
      this.submitData = cloneDeep({
        ...this.defaultValue,
        couponCode: this.defaultValue.coupon ? this.defaultValue.coupon.code : '',
      })
    }
  },
}
</script>
<template>
  <div :class="$style.orderformSection" v-loading="tryingGetMember">
    <div v-if="!totalAllShow" class="orderformSection__all">
      <div ref="leftCont" class="orderformSection__left">
        <div :id="orderHeaderId" :class="$style.header" class="d-md-flex">
          <div class="orderformSection__mobileBack">
            <el-button type="text" class="text-secondary" @click="closeDrawer">
              <BaseIcon name="chevron-left" icon-style="fal" class="mr-2 text-secondary" />
              返回
            </el-button>
          </div>
          <div class="orderformSection__mobileStatus d-md-none d-flex align-items-center">
            <div class="">
              訂單狀態：
              <BaseStateLabel :round="true" class="is-border" :state="defaultValue.status | bookingStatusFilter('color')"
                text>{{
                  defaultValue.status | bookingStatusFilter('text')
                }}</BaseStateLabel>
            </div>
            <el-button type="text" :class="{ transform: showHeader }" @click="showHeader = !showHeader">
              <BaseIcon name="chevron-down" icon-style="fal" class="ml-2 text-secondary" />
            </el-button>
            <el-button v-if="defaultValue.status === 3" class="is-round ml-auto orderformSection__checkInBtn"
              type="success" :disabled="tryingStore" :loading="tryingStore" @click="showCheckinStatusDialog">
              報到
            </el-button>
          </div>
          <div class="orderformSection__header" :class="{ isActive: showHeader }">
            <h5 class="Jost">
              預約時間：{{ editOrderDate | formatDate('dateTime') }}
              <BaseStateLabel v-if="defaultValue.status" round class="ml-3 is-border d-md-inline d-none align-text-top"
                :state="defaultValue.status | bookingStatusFilter('color')" text>{{
                  defaultValue.status | bookingStatusFilter('text')
                }}</BaseStateLabel>
            </h5>
            <h5 class="Jost" :class="$style.title">此時段服務地點：{{ defaultValue.productName }}</h5>
            <template v-if="defaultValue.scheduleItem">
              <h5 class="Jost">美容師：{{ defaultValue.scheduleItem.name }}</h5>
              <!-- 助理 -->
              <template>
                <div :class="$style.editOneLine" style="margin-top: 15px padding:0  20px">
                  <h5 class="editOneLine__title">助理：</h5>
                  <span class="editOneLine__text">{{ helperWordsMethods('helpers') }}</span>
                </div>
              </template>
              <template v-if="$hasSpaceModule()">
                <div :class="$style.editOneLine" style="margin-top: 15px padding:0  20px">
                  <h5 class="editOneLine__title">空間：</h5>
                  <span class="editOneLine__text">{{ helperWordsMethods('spaceHelpers') }} </span>
                </div>
              </template>
            </template>
          </div>
          <div class="header__right">
            <el-button v-if="defaultValue.status === 3" class="is-round orderformSection__bottom__btn-item ml-auto w-100"
              type="primary" :disabled="tryingStore" :loading="tryingStore" @click="showCheckinStatusDialog">
              變更報到狀態
            </el-button>
          </div>
        </div>
        <el-tabs v-model="activeName" class="d-md-none" stretch>
          <el-tab-pane label="訂單資訊" name="info"></el-tab-pane>
          <el-tab-pane label="所有訂單" name="orders"></el-tab-pane>
          <el-tab-pane label="使用人備註" name="note">
            <div style="padding: 20px">
              <BaseCollapse title="使用人備註" is-expand>
                <div class="p-3">
                  <div class="inline-between mb-2">
                    <div style="font-weight: 500; margin-bottom: 10px">使用人資訊</div>
                    <el-button type="text" style="padding-top: 0" size="mini" @click="openNoteEdit">
                      <BaseIcon name="edit" class="text-primary mr-2" />編輯備註
                    </el-button>
                  </div>
                  <ul class="userInfo">
                    <li class="mb-2">{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
                    <li class="mb-2">{{ `${defaultValue.phoneCode} ${defaultValue.phoneNumber}` }}</li>
                    <li class="mb-2" style="display: block">使用人備註：{{ defaultValue.note || '目前尚無備註' }}</li>
                  </ul>
                  <div v-if="!isEmptyByOrderExtrafields" class="byOrderExtrafieldsInfo">
                    <ul v-for="(byOrderExtrafield, byOrderExtrafieldIndex) in defaultValue.byOrderExtrafields"
                      :key="`byOrderExtrafieldIndex-${byOrderExtrafieldIndex}`" :class="$style.question">
                      <li class="title">{{ byOrderExtrafield.title }}</li>
                      <li v-if="byOrderExtrafield.value" class="value">{{ byOrderExtrafield.value }}</li>
                    </ul>
                  </div>
                </div>
              </BaseCollapse>
            </div>

          </el-tab-pane>
        </el-tabs>
        <!-- 客戶資訊 -->
        <div ref="leftCont" class="orderformSection__left__content" :class="{ 'isActive': activeName === 'info' }"
          :style="`height:calc(100vh - ${headerHeight}px)`">
          <div element-loading-background="rgba(0, 0, 0,0)" style="min-height: 300px; padding-top: 20px"
            class="info-section">
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon icon-style="fal" name="address-card"
                    :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                  客戶資訊
                </span>
              </template>
              <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />
            </BaseCollapse>
            <!-- 寵物資訊 -->
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon name="bone" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']"
                    style="transform: rotate(-45deg)" /> {{ $t('reserve.CLIENT') }}資訊
                </span>
              </template>
              <OrderPetInfo :default-value="defaultValue" :pet-list="petList" is-order-detail
                @toDetail="goToPetInfoDetail" />
              <PetCommentList ref="comment" type="order" class="d-none" :order="defaultValue"
                @emitFetch="emitCommentFetch" />
            </BaseCollapse>
            <!-- 服務項目 -->
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon name="cut" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" /> 服務項目
                </span>
              </template>
              <div style="background-color: white;">
                <div class="d-flex align-items-center text-secondary">
                  <div v-if="hasPrepaidParams(defaultValue.params)" class="info-icon isPrepaid">
                    方案抵扣
                  </div>
                  <div v-else class="info-icon">
                    單次預約
                  </div>
                  {{ reservationItem.title }}
                </div>
              </div>
            </BaseCollapse>
            <!-- 到府專用地址 -->
            <template v-if="isHomeService">
              <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span>
                    <BaseIcon name="map-marker-alt" /> 服務地址
                  </span>
                </template>
                <div style="margin-bottom:30px">
                  <div v-if="defaultValue.city" style="margin-bottom:20px">服務地址：{{ defaultValue.city }}{{
                    defaultValue.district }}{{ defaultValue.address }}</div>
                  <el-button v-if="!defaultValue.city" type="text" style="padding-top: 0; text-decoration: underline"
                    @click="openAddressEdit"> 新增服務地址 </el-button>
                  <el-button v-else type="text" style="padding-top: 0; text-decoration: underline"
                    @click="openAddressEdit"> 編輯服務地址 </el-button>
                </div>
              </BaseCollapse>
            </template>
            <!-- 發票資訊 -->
            <template v-if="defaultValue.status === 6 && defaultValue.invoice.InvoiceNumber">
              <BaseCollapse is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span> 發票資訊</span>
                </template>
                <div style="margin-bottom:30px">
                  <div :class="$style.invoice">
                    <div style="margin-bottom:10px"> 預約訂單#{{ defaultValue.id }}</div>
                    <div class="info">
                      <el-row :gutter="20">
                        <el-col :span="12" :xs="24">
                          <div class="info-item">
                            <span class="title">發票日期</span>
                            <span>{{ defaultValue.invoice.CreateTime | formatDate }}</span>
                          </div>
                          <div class="info-item">
                            <span class="title">發票號碼</span>
                            <span>{{ defaultValue.invoice.InvoiceNumber }}</span>
                          </div>
                          <div class="info-item">
                            <span class="title">隨機碼</span>
                            <span>{{ defaultValue.invoice.RandomNum }}</span>
                          </div>
                        </el-col>
                        <el-col :span="12" :xs="24">
                          <div class="info-item">
                            <span class="title">發票形式</span>
                            <span>{{ taxTypeMap[defaultValue.invoice.taxType] }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2C'" class="info-item">
                            <span class="title">載具類別</span>
                            <span>{{ carrierTypeMap[defaultValue.invoice.CarrierType] }}</span>
                          </div>
                          <div
                            v-if="defaultValue.invoice.taxType === 'B2C' && ['0', '1'].includes(defaultValue.invoice.CarrierType)"
                            :span="12" :xs="24" class="info-item">
                            <span class="title">載具編號</span>
                            <span>{{ defaultValue.invoice.CarrierNum }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2B'" class="info-item">
                            <span class="title">統一編號</span>
                            <span>{{ defaultValue.invoice.taxId }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'DONATE'" class="info-item">
                            <span class="title">捐贈碼</span>
                            <span>{{ defaultValue.invoice.LoveCode }}</span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <template v-if="childrenOrdersHaveInvoice.length > 0">
                    <div v-for="addOrder in childrenOrdersHaveInvoice" :key="addOrder.invoice.InvoiceNumber"
                      :class="$style.invoice">
                      <div style="margin-bottom:10px"> 子訂單#{{ addOrder.id }}</div>
                      <div class="info">
                        <el-row :gutter="20">
                          <el-col :span="12" :xs="24">
                            <div class="info-item">
                              <span class="title">發票日期</span>
                              <span>{{ addOrder.invoice.CreateTime | formatDate }}</span>
                            </div>
                            <div class="info-item">
                              <span class="title">發票號碼</span>
                              <span>{{ addOrder.invoice.InvoiceNumber }}</span>
                            </div>
                            <div class="info-item">
                              <span class="title">隨機碼</span>
                              <span>{{ addOrder.invoice.RandomNum }}</span>
                            </div>
                          </el-col>
                          <el-col :span="12" :xs="24">
                            <div class="info-item">
                              <span class="title">發票形式</span>
                              <span>{{ taxTypeMap[addOrder.invoice.taxType] }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'B2C'" class="info-item">
                              <span class="title">載具類別</span>
                              <span>{{ carrierTypeMap[addOrder.invoice.CarrierType] }}</span>
                            </div>
                            <div
                              v-if="addOrder.invoice.taxType === 'B2C' && ['0', '1'].includes(addOrder.invoice.CarrierType)"
                              :span="12" :xs="24" class="info-item">
                              <span class="title">載具編號</span>
                              <span>{{ addOrder.invoice.CarrierNum }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'B2B'" class="info-item">
                              <span class="title">統一編號</span>
                              <span>{{ addOrder.invoice.taxId }}</span>
                            </div>
                            <div v-if="addOrder.invoice.taxType === 'DONATE'" class="info-item">
                              <span class="title">捐贈碼</span>
                              <span>{{ addOrder.invoice.LoveCode }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </template>
                </div>
              </BaseCollapse>
            </template>
            <!-- 簽名 -->
            <BaseCollapse v-if="defaultValue.status === 6" is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span> 簽名</span>
              </template>
              <div style="margin-bottom:20px">
                <el-image :src="defaultValue.signature" :class="$style.image">
                  <div slot="error"> 圖片載入失敗 </div>
                </el-image>
              </div>
            </BaseCollapse>
          </div>
        </div>
      </div>
      <div ref="rightCont" class="orderformSection__right" :class="{ 'isActive': activeName === 'orders' }">
        <div class="d-md-block d-none">
          <!-- 客戶編輯 -->
          <template v-if="editDetailEnabled">
            <MemberForm :default-value="memberInfo" @update="tryToFetchDetail" @close="closeEditMemberForm" />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !editDetailEnabled">
            <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab" :is-employee="isEmployee"
              @update="tryToFetchDetail" @close="closeMemberInfo" />
          </template>
          <!-- 寵物選擇 -->
          <template v-if="petShow">
            <PetList ref="petList" :is-employee="isEmployee" :default-value="defaultValue"
              :active-id="defaultValue.pet.id" :member-info="memberInfo" :pet-info-active-tab="petInfoActiveTab"
              :is-show-pet-list="isShowPetList" @close="closePet" @update="tryToFetchDetail(memberInfo.id)" />
          </template>
          <!-- 編輯到府地址 -->
          <template v-if="addressShow">
            <AddressForm :default-value="currentOrder" :loading="tryingStore" @update="saveHomeAddress"
              @close="closeAddress" />
          </template>
          <!-- 備註編輯 -->
          <template v-if="noteEditShow">
            <NoteForm :current-order="currentOrder" :member-info="memberInfo" :loading="tryingStore"
              @update="tryToStoreNote" @close="closeNoteEdit" />
          </template>
          <!-- 查看歷史紀錄 -->
          <template v-if="orderHistoryShow">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeHistory"><i
                  class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">訂單變更記錄</h4>
            </div>
            <div class="orderformSection__right__content">
              <el-timeline>
                <el-timeline-item v-for="log in currentHistory" :key="log.id"
                  :timestamp="log.created | formatDate('dateTime')" type="primary" placement="top">
                  {{ log.description }}
                  <span style="font-size: 13px">
                    <span v-if="log.creator">- {{ log.creator }}</span>
                  </span>
                  <div v-if="log.note">{{ log.note }}</div>
                </el-timeline-item>
              </el-timeline>
              <!-- <el-button class="is-round is-fullwidth" type="primary" :loading="tryingStore" @click="tryToSaveOrder"> 儲存 </el-button> -->
            </div>
          </template>

          <!-- 編輯付款方式 -->
          <template v-if="editPaymentMethodShow">
            <PaymentEditForm :current-order="currentOrder" :loading="tryingStore" @update="onUpdatePayment"
              @close="closeEditPaymentMethod" />
          </template>
        </div>
        <!-- 變價 -->
        <div :class="$style.total">
          <div class="total__cont">
            <div style="padding: 10px 20px 0" class="d-md-none">
              <el-button v-if="defaultValue.status !== 0" type="primary" class="is-round is-fullwidth"
                @click="openAddOrder">
                <BaseIcon name="plus" /> 新增子訂單
              </el-button>
            </div>
            <TotalStatementDetail order-type="reservation" :default-value="submitData" :member-info="memberInfo"
              :is-employee="isEmployee" @openAdd="openAddEdit" @editOpenTotalEdit="editOpenTotalEdit"
              @editOpenPaymentMethod="editOpenPaymentMethod" @editOpenHistory="editOpenHistory"
              @tryToCancelOrder="tryToCancelOrder" @editOpenRefund="editOpenRefund" @noteEdit="openNoteEdit">
              <div style="padding: 0 0 30px 0" class="d-md-block d-none">
                <el-button v-if="defaultValue.status !== 0" type="primary" class="is-round is-fullwidth"
                  @click="openAddOrder">
                  <BaseIcon name="plus" /> 新增子訂單
                </el-button>
              </div>
            </TotalStatementDetail>
          </div>
        </div>
      </div>
      <!-- 訂單資訊 MobileStyle Start-->
      <div class="d-md-none">
        <!-- 客戶編輯 -->
        <template v-if="editDetailEnabled">
          <MemberForm :default-value="memberInfo" class="orderformSection__mobileOtehrs"
            :style="`height:calc(100vh + ${headerHeight}px + 90px)`" @update="tryToFetchDetail"
            @close="closeEditMemberForm" />
        </template>
        <!-- 客戶資訊 -->
        <template v-if="memberInfoShow && !editDetailEnabled">
          <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab" :is-employee="isEmployee"
            class="orderformSection__mobileOtehrs" :style="`height:calc(100vh + ${headerHeight}px + 90px)`"
            @update="tryToFetchDetail" @close="closeMemberInfo" />
        </template>
        <!-- 寵物選擇 -->
        <template v-if="petShow">
          <PetList ref="petList" :is-employee="isEmployee" :default-value="defaultValue" :active-id="defaultValue.pet.id"
            :member-info="memberInfo" :pet-info-active-tab="petInfoActiveTab" :is-show-pet-list="isShowPetList"
            class="orderformSection__mobileOtehrs" :style="`height:calc(100vh + ${headerHeight}px + 90px)`"
            @close="closePet" @update="tryToFetchDetail(memberInfo.id)" />
        </template>
        <!-- 編輯到府地址 -->
        <template v-if="addressShow">
          <AddressForm :default-value="currentOrder" :loading="tryingStore" @update="saveHomeAddress"
            @close="closeAddress" />
        </template>
        <!-- 備註編輯 -->
        <template v-if="noteEditShow">
          <NoteForm :current-order="currentOrder" :member-info="memberInfo" :loading="tryingStore"
            class="orderformSection__mobileOtehrs" :style="`height:calc(100vh + ${headerHeight}px + 90px)`"
            @update="tryToStoreNote" @close="closeNoteEdit" />
        </template>
        <!-- 查看歷史紀錄 -->
        <template v-if="orderHistoryShow">
          <div class="orderformSection__mobileOtehrs" :style="`height:calc(100vh + ${headerHeight}px + 90px)`">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeHistory"><i
                  class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">訂單變更記錄</h4>
            </div>
            <div class="orderformSection__right__content">
              <el-timeline>
                <el-timeline-item v-for="log in currentHistory" :key="log.id"
                  :timestamp="log.created | formatDate('dateTime')" type="primary" placement="top">
                  {{ log.description }}
                  <span style="font-size: 13px">
                    <span v-if="log.creator">- {{ log.creator }}</span>
                  </span>
                  <div v-if="log.note">{{ log.note }}</div>
                </el-timeline-item>
              </el-timeline>
              <!-- <el-button class="is-round is-fullwidth" type="primary" :loading="tryingStore" @click="tryToSaveOrder"> 儲存 </el-button> -->
            </div>
          </div>
        </template>

        <!-- 編輯付款方式 -->
        <template v-if="editPaymentMethodShow">
          <PaymentEditForm :current-order="currentOrder" :loading="tryingStore" class="orderformSection__mobileOtehrs"
            :style="`height:calc(100vh + ${headerHeight}px + 90px)`" @update="onUpdatePayment"
            @close="closeEditPaymentMethod" />
        </template>
      </div>
      <!-- 訂單資訊 MobileStyle End-->
      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div style="display: flex; align-items: center; flex-shrink: 0; " class="orderformSection__bottom__left">
          <BaseStateLabel :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')"
            class="is-border is-round mr-2">{{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}
          </BaseStateLabel>
          <div class="Jost text-secondary pl-md-4 ml-0">
            NT$ {{ defaultValue.allActualPayTotal }}
            <span v-if="defaultValue.allUnpaidTotal" class="Jost"
              style="color:#e35d5d;margin-left:5px;font-size:12px;display:inline-block"> ( 未付款金額 NT${{
                defaultValue.allUnpaidTotal }} )</span>
            <br />
            <BaseStateLabel class="text-muted-0" style="padding-top: 5px" state="info" text>{{ defaultValue.paymentMethod
              | orderPaymentMethodFilter }}</BaseStateLabel>
          </div>
        </div>

        <div v-if="!isEmployee" style="padding:0 10px; margin-left: auto;">
          <el-button class="no-color-text-btn is-circle is-border" style="font-size: 20px; margin-right: 5px"
            @click="writeDialogVisible = true">
            <BaseIcon name="envelope" :icon-style="'fal'"></BaseIcon>
          </el-button>
          <el-button v-if="defaultValue.status !== 5 && defaultValue.status !== 0" style="font-size: 20px"
            class="is-boeder icon-text no-color-text-btn is-circle" @click="showShareDialog">
            <BaseIcon name="paper-plane" :icon-style="'fal'"></BaseIcon>
          </el-button>

          <!-- 撰寫通知 -->
          <BaseButtonDialog :only-dialog="true" :title="'撰寫通知'" :dialog-visible.sync="writeDialogVisible" :destroy="true"
            floating>
            <NotificationWrite :selected-order-ids="[defaultValue.id]" source-name="order" :source-order="defaultValue"
              @close="closeNotificationDialog" />
          </BaseButtonDialog>
          <!-- 分享連結 -->
          <el-dialog title="選擇發送方式" :visible.sync="shareDialogVisible" top="0" width="680px" append-to-body lock-scroll
            @open="tryToGetShareLink">
            <ul class="p-3 mb-3" style="border-radius: 8px; background: $color-line">
              <li class="text-primary mb-3">{{ `#${defaultValue.id}` }}</li>
              <li class="mb-3">使用人：{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
              <li>訂購內容：{{ defaultValue.productName }} {{ defaultValue.date | formatDate }} {{ defaultValue.time }}</li>
            </ul>
            <div :class="$style['share__buttons']">
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']"
                  @click="handleShareLink('facebook')">
                  <i class="fab fa-facebook-square" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">Facebook</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']"
                  @click="handleShareLink('line')">
                  <BaseIcon :class="$style['share__icon']" name="line" icon-style="fab" />
                </el-button>
                <div :class="$style['share__label']">Line</div>
              </div>
              <div :class="$style['share__button']" :loading="tryingSendSMS">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="tryToSendSMS">
                  <i class="fas fa-sms" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">簡訊</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="copyShareLink">
                  <i class="fas fa-copy" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">複製連結</div>
              </div>
            </div>
          </el-dialog>
        </div>

        <div class="orderformSection__bottom__right">
          <el-button v-if="defaultValue.status !== 0 &&
            defaultValue.paymentStatus === 'UNPAID' &&
            defaultValue.paymentMethod !== 'Credit' &&
            defaultValue.paymentMethod !== 'Vacc' &&
            defaultValue.paymentMethod !== 'Prepaid' &&
            !isEmployee
            " class="is-round orderformSection__bottom__btn-item" type="success" :loading="tryingPayOrder"
            @click="openPaidDialog">付款</el-button>
          <el-button
            v-if="!isEmployee && unPaidAddOrder && unPaidAddOrder.id && unPaidAddOrder.paymentStatus === 'UNPAID' && unPaidAddOrder.paymentMethod !== 'Credit' && unPaidAddOrder.paymentMethod !== 'Vacc'"
            class="is-round orderformSection__bottom__btn-item" type="success" :loading="tryingPayOrder"
            @click="openAddPaidDialog">付款子訂單</el-button>
          <template v-if="!isEmployee && defaultValue.prepaidOrderStatus === 2">
            <div style="display:inline-block; flex-shrink: 0;">
              <el-alert style="display:inline-block; width:auto;top:14px;left:0;margin-left:10px" type="error"
                :closable="false">
                <span slot="title" class="">{{ $t('prepaid.BASE') }}訂單未付款</span>
              </el-alert>
              <el-button type="text" style="padding-top: 0; text-decoration: underline;margin-left:10px"
                @click="goToPrepaidOrder(defaultValue.prepaidOrderUuid)"> 前往 </el-button>
            </div>
          </template>
          <el-button
            v-if="defaultValue.status === 4 && isPaid && !unPaidAddOrder && defaultValue.prepaidOrderStatus !== 2"
            class="is-round orderformSection__bottom__btn-item" type="primary" @click="showSignDialog">簽名確認</el-button>
          <template v-if="defaultValue.status === 4">
            <el-alert v-if="!isPaid || unPaidAddOrder" class="orderformSection__bottom__right__alert" style=""
              type="error" :closable="false">
              <span slot="title">請將訂單及子訂單款項結清，<br />始可完成簽名請款</span>
            </el-alert>
          </template>
        </div>
      </div>
      <!-- 報到與未報到 -->
      <el-dialog :visible.sync="CheckinStatusDialogVisible" width="40%" top="0" custom-class="small-dialog"
        :close-on-click-modal="false" append-to-body>
        <div slot="title">
          <div class="circle-icon bg-success">
            <BaseIcon name="check"></BaseIcon>
          </div>
          <h4 style="margin-bottom: 10px">報到狀態</h4>
        </div>
        <el-button type="primary" class="is-round is-fullwidth" @click="openCheckDialog"> 已報到 </el-button>
        <el-button type="primary" class="is-round is-fullwidth" @click="noShowDialogVisible = true"> 未報到 </el-button>
      </el-dialog>
      <!-- 報到 -->
      <el-dialog v-if="defaultValue.scheduleItem" :title="'確認將此訂單改為「已報到」'" width="550px"
        :visible.sync="checkDialogVisible" top="0" append-to-body>
        <el-form ref="beauticianForm" :model="check" :rules="helpSubmitRules" class="p-3 pb-2" label-width="100px"
          label-position="left" style="background: $color-line">
          <el-form-item label="美容師" class="mb-2">
            {{ defaultValue.scheduleItem ? defaultValue.scheduleItem.name : '' }}
          </el-form-item>
          <div v-if="isEmployee" v-loading="tryingAssign" element-loading-background="rgba(0, 0, 0,0)">
            <el-form-item label="助理" prop="assistant" class="mb-2">
              <span v-if="!defaultValue.helper" class="editOneLine__text">尚未指定 </span>
              <span v-if="defaultValue.helper" class="editOneLine__text">{{ defaultValue.helper.name }} </span>
            </el-form-item>
          </div>
          <div v-else v-loading="tryingAssign" element-loading-background="rgba(0, 0, 0,0)">
            <el-form-item v-if="assignList.length > 0" label="助理" prop="assistant" class="mb-2">
              <el-select v-model="check.helperId">
                <el-option label="不指派" value></el-option>
                <el-option v-for="(item, index) in assignList" :key="index" :value="item.id"
                  :label="`${item.name} ${item.sameStore ? '(同分店)' : '(不同分店)'}`"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="assignList.length === 0 && !tryingAssign" label="助理" prop="assistant" class="mb-2">
              <div>目前無人員可指派</div>
            </el-form-item>
          </div>
        </el-form>

        <div style="margin-top: 20px">
          <el-button class="is-round w-100" type="primary" :loading="tryingCheckIn"
            @click="tryToStoreAssignAndCheckIn">確認</el-button>
          <el-button class="is-round w-100 mt-3 ml-0" @click="checkDialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 未報到 -->
      <el-dialog title="請說明未報到情況" width="550px" :visible.sync="noShowDialogVisible" top="0" append-to-body>
        <el-form ref="form" :model="submitData"
          :rules="{ note: [{ required: true, message: '請輸入情況！', trigger: 'blur' }] }">
          <el-form-item prop="note">
            <el-input v-model="submitData.note" type="textarea" class="is-round is-light is-border" :rows="4"
              placeholder="請輸入備註"></el-input>
          </el-form-item>
        </el-form>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="24">
            <el-button :loading="tryingNoShow" :disabled="tryingNoShow" type="danger" class="is-round is-fullwidth"
              @click="onClickNoShow">未報到</el-button>
          </el-col>
          <el-col :span="24">
            <el-button class="is-round is-fullwidth mt-3" @click="noShowDialogVisible = false">返回</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 退款 -->
      <el-dialog title="退款" width="550px" :visible.sync="orderRefundShow" top="0" append-to-body destroy-on-close>
        <RefundForm :current-order="currentOrder" :loading="tryingRefund" @submit="tryToRefund"
          @close="closeOpenRefund" />
      </el-dialog>
    </div>
    <!-- 變價或加購 -->
    <div v-if="totalAllShow" class="orderformSection__all" :class="{ 'isStyleIsEmployee': isEmployee }"
      :style="`height:calc(100vh + ${headerHeight}px + 90px)`">
      <div class="orderformSection__right" style="border-right: #dcdfe6 1px solid">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button"
            @click.stop="isChildrenOrderCreating ? closeChildren() : cancelToTalEdit()"><i
              class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span v-if="isChildrenOrderCreating"> 新增子訂單 </span>
              <span v-else> 價格編輯與折扣 </span>
            </div>
          </h4>
        </div>

        <div class="orderformSection__right__content" style="padding: 0 0 20px 0">
          <!-- 未付款前可編輯優惠券 -->
          <TotalStatement enabled-edit enabled-addition is-order-created :is-employee="isEmployee"
            :is-children-order-creating="isChildrenOrderCreating" order-type="reservation" :member-info="memberInfo"
            :default-value="isChildrenOrderCreating ? childrenSubmitData : currentOrder" :default-coupon="couponInfo"
            @openAdd="openAddEdit" @openChange="openChangeEdit" @openTotalEdit="openTotalEdit"
            @update="onUpdateTotalStatement">
            <div :class="$style.bottom" style="padding: 0 0 26px;">
              <template v-if="isChildrenOrderCreating">
                <div class="children__bottom">
                  <el-button style="margin-top: 20px; width: 100%" class="is-round orderformSection__bottom__btn"
                    type="primary" :disabled="tryingStore || childrenSubmitData.params.length === 0"
                    :loading="tryingStore" @click="handleStoreOrder">
                    新增子訂單
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-form v-if="isCouponEditable && !isEmployee" ref="couponForm" :model="submitData" :rules="submitRules">
                  <el-form-item ref="couponCode" class="el-form-item--white-bg" prop="couponCode">
                    <el-input v-model="submitData.couponCode" clearable :disabled="!!hasCouponInfo" placeholder="請輸入優惠券代碼"
                      class="isStyleButton">
                      <el-button v-if="hasCouponInfo" slot="append" class="is-round is-border"
                        @click="resetCoupon">清除優惠券</el-button>
                      <el-button v-else slot="append" type="primary" class="is-round" :loading="tryingValidCouponCode"
                        @click="validCoupon">使用優惠券</el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="btn-group-inline">
                  <el-button class="is-round" type="primary" :loading="tryingStoreOrderItem"
                    @click="tryToStoreOrderItem">確認修改</el-button>
                </div>
              </template>
            </div>
          </TotalStatement>
        </div>
      </div>
      <div class="orderformSection__left" style="border: 0" :class="{ 'isStyleEmployee totalAllShow': isEmployee }"
        :style="`height:calc(100vh + ${headerHeight}px + 90px)`">
        <div class="orderformSection__left__content" style="padding-bottom: 0">
          <template v-if="visibleAdditionForm">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeAdd"><i
                  class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">
                <div class="inline-between" style="padding-right: 15px; align-items: center"> 加購 </div>
              </h4>
            </div>
            <div class="info-section">
              <AdditionFormOrder ref="addForm" :is-edit-mode="true" :this-time-selected-pet-info="thisTimeSelectedPetInfo"
              :setServicesMemberLevelPrice="setServicesMemberLevelPrice"  
              :pet-size-id="petSizeId" :default-value.sync="defaultValue" @submit="onSubmitAddition"
                @close="closeAdd" />
              <!-- @update="updateDefaultValue" -->
            </div>
          </template>
          <TotalEdit v-else @submit="onSubmitTotalEdit"></TotalEdit>
        </div>
      </div>
    </div>
    <!-- 變價跟加價 MobileStyle Start-->
    <div v-if="visibleAdditionForm" class="d-md-none orderformSection__AdditionForm" style="border: 0"
      :class="{ 'isStyleEmployee': isEmployee }">
      <div class="">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeAdd"><i
              class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center"> 加購 </div>
          </h4>
        </div>
        <div class="info-section">
          <AdditionFormOrder ref="addForm" :is-edit-mode="true" :this-time-selected-pet-info="thisTimeSelectedPetInfo"
          :setServicesMemberLevelPrice="setServicesMemberLevelPrice"  
          :pet-size-id="petSizeId" :default-value.sync="defaultValue" @submit="onSubmitAddition" @close="closeAdd" />
          <!-- @update="updateDefaultValue" -->
        </div>
      </div>
    </div>
    <div v-if="visibleTotalEdit" class="d-md-none orderformSection__TotalEdit" style="border: 0"
      :class="{ 'isStyleEmployee': isEmployee }">
      <div class="">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeChange">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">變價</div>
          </h4>
        </div>
        <TotalEdit @submit="onSubmitTotalEdit"></TotalEdit>
      </div>
    </div>
    <!-- 變價跟加價 MobileStyle End-->
    <!-- 簽名請款 -->
    <SignatureDialog :key="signDialogKey" :visible.sync="signDialogVisible" :order="{ ...defaultValue }"
      @update="updateOrder" />

    <!-- 選擇付款方式和訂單狀態 -->
    <PaymentFormDialog :visible.sync="paymentDialogVisible" :payment-way="paymentWay" :loading="tryingStore"
      @submit="onSubmitPaymentForm" />

    <OrderChangeStatusDialog :container-all-item="{}" :visible.sync="statusDialogVisible"
      :order="{ ...currentOrder, status: 0 }" @cancelled="updateOrder" />

    <!-- 付款確認 -->
    <DialogPaidConfirm v-model="paidConfirmValue" :visible.sync="isDialogPaidConfirmVisible"
      :is-children="!!unPaidAddOrder && !!unPaidAddOrder.id" @submit="paidConfirm" />

    <!-- 新增儲值金訂單 -->
    <el-drawer ref="depositOrderForm" class="only-close" :class="{ 'appStyle': appStyle }"
      :visible.sync="createDepositOrderVisible" :append-to-body="true" :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close :modal-append-to-body="false" :wrapper-closable="false" custom-class="order-drawer">
      <DepositOrderForm :order-member-id="memberInfo.id" order-type="deposit" @store="onCreateDepositOrderDone" />
    </el-drawer>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {

  // display: flex;
  // flex-wrap: wrap;
  // height: 100%;
  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .el-form-item {
      // margin-bottom: 10px;
    }

    .el-tabs__active-bar {
      background-color: $color-primary !important;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100%;

        // display: none;
        &.isStyleIsEmployee {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          height: 100vh;

          .orderformSection__right {
            display: block;
          }

          .orderformSection__left__content {
            display: block;
          }
        }
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        @include max-md {
          position: sticky;
        }

        &__content {
          height: 100vh;
          overflow: auto;

          padding-bottom: 90px;

          @include max-md {
            display: none;
            padding-bottom: 110px !important;

            &.isActive {
              display: block;
            }
          }

          @include touch {
            padding-bottom: 110px !important;
          }
        }

        &.isStyleEmployee {
          &.totalAllShow {
            @include max-md {
              display: none;
            }
          }
        }
      }

      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        @include max-md {
          display: none;

          &.isActive {
            display: block;
          }
        }

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;
          background: $color-line;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }

          @include touch {
            height: calc(100vh - 30px);
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          // position: static;
          position: sticky;
          flex-wrap: wrap;
          padding: 15px;
          justify-content: flex-start;
        }

        &__left {
          @include touch {
            width: 100%;
          }
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          // min-width: 132px;
          width: 360px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }

        &__right {
          display: flex;
          align-items: center;
          margin-left: 1rem;

          &__alert {
            display: inline-block;
            width: auto;
            margin-left: 20px;
            flex-shrink: 0;

            @include touch {
              width: 100%;
              margin-left: 0;
              margin-top: 1rem;
            }
          }

          @include touch {
            display: block;
            width: 100%;
            margin-left: 0;
            order: -1;
            margin-bottom: 10px;
          }
        }
      }

      &__mobileBack {
        border-bottom: 1px solid $color-line;
        margin-left: -20px;
        margin-right: -20px;
        margin-bottom: 1rem;
        padding: 5px 20px;
        display: none;

        @include max-md {
          display: block;
        }
      }

      &__mobileOtehrs {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        // background: $color-line;
      }

      &__mobileStatus {

        // margin-bottom: 1rem;
        // border-bottom: 1px solid #eee;
        // padding-bottom: 1rem;
        .el-button {
          svg {
            transition: .3s
          }

          &.transform {
            svg {
              transform: rotate(180deg);
            }
          }
        }
      }

      &__header {
        border-top: 1px solid transparent;
        margin-left: -20px;
        margin-right: -20px;
        padding: 0 20px;

        @include max-md {
          max-height: 0;
          overflow: hidden;
          transition: max-height .3s;
          margin-top: 1rem;

          h5 {
            font-size: 14px;
            font-weight: 400;
          }
        }

        &.isActive {
          @include max-md {
            border-color: $color-line;
            max-height: 1000px;
            overflow: auto;
          }
        }
      }

      &__AdditionForm {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        // height: 100%;
        z-index: 1000;
        background: $color-line;

        .orderformSection__right__header {
          position: sticky;
        }

        .el-drawer__close-btn {}

        .orderformSection__right__title {
          // padding: 27px 0;
        }
      }

      &__TotalEdit {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        // height: 100%;
        z-index: 1000;
        background: $color-line;

        .orderformSection__right__header {
          position: sticky;
        }

        .el-drawer__close-btn {}

        .orderformSection__right__title {
          // padding: 27px 0;
        }
      }

      &__checkInBtn {
        max-width: 100% !important;
        width: 175px !important;

        @include max-lg {
          width: 90px !important;
        }
      }
    }

    .info-icon {
      color: #fff;
      background-color: $color-primary;
      display: inline-block;
      margin-right: 1rem;
      padding: 7px 10px;
      font-weight: 300;
      font-size: 12px;
      flex-shrink: 0;

      &.isPrepaid {
        background-color: #2D385F;
      }
    }
  }
}

.header {
  margin-top: 5px;
  // margin-bottom: 30px;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 5px;
  }

  :global {
    h5 {
      font-size: 18px;
    }

    .header {
      &__right {
        margin-left: auto;
        align-self: end;
        margin-bottom: 1rem;

        @include max-md {
          margin-bottom: 0;
          display: none;
        }
      }
    }
  }
}

.infoList {
  // margin-bottom: 30px;
  padding-top: 5px;

  // border-bottom: 1px solid $color-border-base;
  // font-size: 16px;
  :global {
    .muted {
      color: $color-text-secondary;
    }

    .el-tag+.el-tag {
      margin-left: 10px;
    }

    .infoList {
      &__title {
        font-weight: 500;
        margin-bottom: 20px;
      }

      &__item {
        margin-bottom: 15px;
      }

      &__row {
        margin-bottom: 20px;
      }
    }
  }
}

.detail li {
  line-height: 40px;
}

// 地址
.footer {
  display: flex;

  :global {
    button {
      flex: 1 0 auto;
    }
  }
}

// 服務
.price {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: $color-border-base 1px solid;

  &:global {
    &:hover {
      .price__title {
        color: $color-primary;
        transition: all 0.35s;
      }
    }

    &.isActive {
      .price__title {
        color: $color-primary;
        // transition: all 0.35s;
      }
    }

    &.isDisabled {
      pointer-events: none;
    }
  }

  :global {
    .price {
      &__image {
        width: 50%;
        height: 10vw;
        border: 0;

        @include max-md {
          height: auto;
        }
      }

      &__cont {
        width: 50%;
        padding-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      &__title {
        font-weight: 500;
        margin-bottom: 10px;
        padding-top: 10px;
      }
    }

    .text-muted-0 {
      font-size: 14px;
    }
  }
}

.prepaid {
  :global {
    .prepaid {
      &__image {
        width: 100%;
        height: 20vw;
        border: 0;
        margin-bottom: 10px;
      }

      &__title {
        font-weight: 500;
      }
    }
  }
}

// 變價
:global {
  .children__bottom {
    padding: 30px 30px 0;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: $color-border-base 1px solid;

    @include touch {
      position: static;
      padding: 30px 0px 0;
    }

    h6 {
      margin-top: 0;
    }

    :global {
      .el-radio-group {
        display: flex;

        @include touch {
          flex-wrap: wrap;
        }
      }

      .el-radio {
        margin-right: 0;
        padding-right: 12px;
        border-radius: 7px;
        margin-left: 0;
        width: 100%;
        background-color: #fff;

        @include touch {
          margin-left: 0;
          margin-bottom: 10px;
        }
      }

      .el-radio.is-bordered+.el-radio.is-bordered {
        @include touch {
          margin-left: 0;
        }
      }
    }
  }

  .payment-radio {
    // padding: 30px 30px 0;
    // position: absolute;
    // left: 0;
    // bottom: 0;
    width: 100%;

    // border-top: $color-border-base 1px solid;
    h6 {
      margin-top: 0;
    }

    :global {
      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        margin-right: -15px;
      }

      .el-radio {
        margin-right: 15px;
        // padding-right: 12px;
        border-radius: 7px;
        margin-left: 0 !important;
        width: calc(50% - 15px);
        background-color: #fff;
        margin-bottom: 15px;
      }
    }
  }
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        // padding: 30px 30px;
        height: calc(100% - 80px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        padding: 30px 30px;
        position: absolute;
        bottom: 80px;
        width: 100%;
        border-top: $color-border-base 1px solid;

        h6 {
          margin-top: 0;
        }

        :global {
          .el-radio-group {
            display: flex;
          }

          .el-radio {
            margin-right: 0;
            padding-right: 12px;
            border-radius: 7px;
            margin-left: 0;
            width: 100%;
            background-color: #fff;
          }
        }
      }
    }
  }
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}

.editOneLine {
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  margin-bottom: 10px;

  :global {
    .el-form-item__error {
      position: static;
      width: 100%;
      padding-left: 80px;
    }

    .editOneLine {
      &__title {
        margin: 0;
        // margin-right: 15px;
      }

      &__text {
        font-size: 1.2rem;
        margin-right: 15px;

        @include max-md {
          font-size: 14px;
          color: $color-secondary;
        }
      }
    }

    .el-form-item {
      margin-bottom: 0;
      margin-right: 15px;

      &.isFull {
        margin-bottom: 20px;
      }
    }

    .el-input__inner {
      background-color: #fff;
      height: 40px;
    }
  }
}

.titleBox {
  padding: 20px;
  background: #fff;
}

.box {
  display: flex;
  flex-wrap: wrap;
  // padding: 20px 20px 10px;
  // background: #fff;
  margin-bottom: 20px;

  :global {
    li {
      //  width: 50%;
      margin-bottom: 15px;
      margin-right: 30px;
    }

    .row-line {
      width: 100%;
    }
  }
}

.info {
  padding-inline-start: 0;

  >li {
    display: inline-block;
    color: #909399;
    padding: 5px 0;
    margin-right: 15px;
  }
}

.share {
  &__buttons {
    display: flex;
    align-items: center;
    text-align: center;
  }

  &__button {
    flex: 1;
  }

  &__icon {
    font-size: 3rem;
  }

  &__label {
    margin-top: 10px;
  }
}

.invoice {
  :global {
    .order-id {
      font-size: 16px;
      letter-spacing: 1.6px;
      line-height: 18px;
      margin-bottom: 20px;
      font-weight: 500;
    }

    .info {
      padding: 22.5px 20px;
      background: white;

      @include touch {
        border: 1px solid #c6c6ba;
      }

      .el-col {
        padding-top: 7.5px;
        padding-bottom: 7.5px;
      }

      .info-item {
        .title {
          width: 60px;
          display: inline-block;
          color: #919191;
          margin-right: 20px;
        }

        &+.info-item {
          margin-top: 15px;
        }
      }
    }
  }

  &+.invoice {
    margin-top: 40px;
  }
}</style>
